import * as r from "@sentry/vue";
let i = !1;
async function o({
  app: e,
  dsn: n = process.env.VITE_SENTRY_DSN,
  ...t
} = {}) {
  if (!n)
    throw new Error("Sentry misconfigured");
  r.init({
    app: e,
    dsn: n,
    environment: process.env.VITE_APP_ENV,
    ...t
  }), i = !0;
}
function c(...e) {
  if (i)
    return r.captureException(...e);
  console.error(...e);
}
export {
  c as captureException,
  o as initializeSentry
};
